import React from 'react';

const Support: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            当事務所のサポート内容と費用
          </h2>
          <p className="text-xl text-gray-600">
            初回相談無料・明確な料金体系
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* 初回相談 */}
          <div className="bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-2xl p-8 mb-8 shadow-xl">
            <div className="flex items-center mb-4">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mr-6">
                <i className="ri-chat-smile-3-line text-4xl"></i>
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-2">初回相談</h3>
                <p className="text-orange-100 text-lg">まずはお気軽にご相談ください</p>
              </div>
            </div>
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
              <div className="flex items-center justify-between mb-4">
                <span className="text-xl font-bold">相談料</span>
                <span className="text-4xl font-bold">無料</span>
              </div>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 mt-1"></i>
                  <span>対面またはWeb会議で実施</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 mt-1"></i>
                  <span>現在の状況をお伺いし、最適な解決方法をご提案</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 mt-1"></i>
                  <span>費用の見積もりを明確にご説明</span>
                </li>
              </ul>
            </div>
          </div>

          {/* サポート内容 */}
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-orange-300 hover:shadow-lg transition-all duration-200">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-discuss-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">交渉サポート</h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-orange-500 mr-2 mt-1">●</span>
                  <span>共有者との交渉代行</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-2 mt-1">●</span>
                  <span>遺産分割協議のサポート</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-2 mt-1">●</span>
                  <span>売却条件の調整</span>
                </li>
              </ul>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-600 mb-2">着手金</p>
                <p className="text-2xl font-bold text-gray-900">30万円〜</p>
                <p className="text-sm text-gray-500 mt-1">※ケースにより異なります</p>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-orange-300 hover:shadow-lg transition-all duration-200">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-scales-3-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">訴訟サポート</h3>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-orange-500 mr-2 mt-1">●</span>
                  <span>共有物分割請求訴訟</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-2 mt-1">●</span>
                  <span>不在者財産管理人選任申立て</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-2 mt-1">●</span>
                  <span>判決後の執行手続き</span>
                </li>
              </ul>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-600 mb-2">着手金</p>
                <p className="text-2xl font-bold text-gray-900">50万円〜</p>
                <p className="text-sm text-gray-500 mt-1">※ケースにより異なります</p>
              </div>
            </div>
          </div>

          {/* 成功報酬 */}
          <div className="bg-white rounded-xl p-8 border-2 border-orange-200">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-trophy-line text-2xl text-orange-500 mr-3"></i>
              成功報酬
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <p className="text-gray-700 mb-2">売却成功時</p>
                <p className="text-3xl font-bold text-gray-900">売却価格の10%</p>
                <p className="text-sm text-gray-500 mt-1">※最低30万円</p>
              </div>
              <div>
                <p className="text-gray-700 mb-2">持分買取成功時</p>
                <p className="text-3xl font-bold text-gray-900">取得金額の10%</p>
                <p className="text-sm text-gray-500 mt-1">※最低30万円</p>
              </div>
            </div>
          </div>

          {/* 注意事項 */}
          <div className="mt-8 bg-blue-50 rounded-xl p-6 border-2 border-blue-200">
            <h4 className="font-bold text-gray-900 mb-4 flex items-center">
              <i className="ri-information-line text-blue-600 text-xl mr-2"></i>
              費用について
            </h4>
            <ul className="space-y-2 text-gray-700 text-sm">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2 mt-1">●</span>
                <span>上記は目安です。具体的な費用は、状況をお伺いした上でお見積りいたします。</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2 mt-1">●</span>
                <span>実費（印紙代、郵送費、交通費など）は別途ご負担いただきます。</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2 mt-1">●</span>
                <span>分割払いのご相談も承ります。</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
